<template>
    <div>
        <el-card class="card-line-header">
            <el-row>
                <el-col :span="8"><label>编号:{{getDetailOrNot?tableHeader2&&tableHeader2.serialNumber:tableHeader&&tableHeader.serialNumber}}</label></el-col>
                <el-col :span="8"><label>创建人:{{tableHeader&&tableHeader.createUser}}</label></el-col>
                <el-col :span="8"><label>巡检组:{{tableHeader&&tableHeader.handlerGroup}}</label></el-col>
            </el-row>
            <el-row>
                <el-col :span="8"><label>巡检人员:{{tableHeader&&tableHeader.currentHandler}}</label></el-col>
                <el-col :span="16"><label>巡检时间:{{getDetailOrNot?tableHeader2&&tableHeader2.inspectTime:formatDateTime(new Date())}}</label></el-col>
            </el-row>
        </el-card>
        <el-card>
                <el-table :data="tableData" v-loading="!loading"  border>
                    <el-table-column label="检查项" prop="checkItem"></el-table-column>
                    <el-table-column label="操作提示/正常值" prop="operationPrompt"></el-table-column>
                    <el-table-column label="结论" prop="conclusion">
                        <template slot-scope="scope">
                            <el-radio v-model="scope.row.conclusion" label="true" v-if="!(scope.row.checkItem==='补丁(如果有装补丁，请详细登记补丁名称与对应服务器名称)'||scope.row.checkItem==='防病毒')" :disabled="editBtn">正常</el-radio>
                            <el-radio v-model="scope.row.conclusion" label="false" v-if="!(scope.row.checkItem==='补丁(如果有装补丁，请详细登记补丁名称与对应服务器名称)'||scope.row.checkItem==='防病毒')" :disabled="editBtn">异常</el-radio>
                            <el-radio v-model="scope.row.conclusion" label="true" v-if="scope.row.checkItem==='补丁(如果有装补丁，请详细登记补丁名称与对应服务器名称)'||scope.row.checkItem==='防病毒'" :disabled="editBtn">是</el-radio>
                            <el-radio v-model="scope.row.conclusion" label="false" v-if="scope.row.checkItem==='补丁(如果有装补丁，请详细登记补丁名称与对应服务器名称)'||scope.row.checkItem==='防病毒'" :disabled="editBtn">否</el-radio>

                        </template>
                    </el-table-column>
                    <el-table-column label="情况摘要" prop="summary">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.summary" :disabled="editBtn"></el-input>
                        </template>
                    </el-table-column>

                        <!--<template slot-scope="scope">-->
                        <!--{{ scope.row.status | tableVal(changeStatus) }}-->
                        <!--</template>-->

                </el-table>
                <div style="margin-top: 10px" v-if="type!=='view'">
                    <el-button type="primary" size="small" @click="submit">确定</el-button>
                    <el-button type="default" size="small" @click="onCancel">取消</el-button>
                </div>




        </el-card>
    </div>
</template>

<script>
    import services from './inspection.service'
    import {tableDefaultData,change}from './inspection.config'
    // let changeArr=change()
    export default {
        props:{
            type:String,
            callback:Function,
            tableHeader:Object,
            id:Number,
            getDetailOrNot:Boolean
        },
        data(){
            return{
                tableData:[],
                // tableArr:[],
                tableHeader2:{},
                loading:true,
                editBtn:false
            }
        },
        created(){
            let changeArr=change()
            // console.log(this.tableData);
            // console.log(this.tableHeader);
            // console.log(this.callback);
            if (this.type=='view'){
                this.editBtn=true
            }
            if (this.getDetailOrNot){
                this.getDetailView()
            }

            // console.log(tableDefaultData);
            // console.log(changeArr);
            // changeArr=tableDefaultData
            this.tableData=changeArr

        },
        computed:{
           inspectTime(){
               return this.tableHeader2.inspectTime
           }
        },
        methods:{
            //巡检记录页面点击查看时要获取详情
            getDetailView(){
                services.getViewDetail({id:this.id}).then(res=>{
                    this.tableHeader2=res
                    let arr=res.inspectItems
                    // console.log(res.inspectItems);
                    // console.log(arr);
                    let correctTable=this.conclusionToStr(arr)
                    this.tableData=correctTable

                    // console.log(this.tableData,'获取详情后的tableData');
                    // this.tableHeader=res
                })
            },
            //详情获得的列表信息中将conclusion（布尔值）转化成字符串
            conclusionToStr(arr){
                arr.forEach(item=>{
                    item.conclusion=item.conclusion.toString()
                })
                return arr
            },
            //巡检时间格式化处理,仅仅用于填写表单时的展示，实际的巡检时间是在提交时后端去获取存储
             formatDateTime(date) {
                let y = date.getFullYear();
                let m = date.getMonth() + 1;
                m = m < 10 ? ('0' + m) : m;
                let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();
                h=h < 10 ? ('0' + h) : h;
                let minute = date.getMinutes();
                minute = minute < 10 ? ('0' + minute) : minute;
                let second=date.getSeconds();
                second=second < 10 ? ('0' + second) : second;
                return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
            },
            submit(){
                let params=this.getParams()
                services.registerTable(params).then(res=>{
                    this.$message.success('表单填写成功')
                    this.close(true)
                })
                // console.log(this.tableData);
            },
            getParams(){
                return {
                    taskId:this.id,
                    inspectItems:this.tableData
                }
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
        }
    }
</script>

<style scoped>

</style>
